import React, { useEffect } from 'react';
import MainMenu from '../components/MainMenu/MainMenu';
import * as ValidateModel from '../shared/ValidateModel';
import SnackBarType from '../objects/app/snackbar';
import { useDispatch } from 'react-redux';
import * as actions from '../store/actions';
import { useTranslation } from 'react-i18next';

interface Props {
    admin: boolean;
}

declare global {
    interface Window {
        MENU_ADD_TEXT: string;
        MENU_ADD_TEXT_TEAM_NAME: string;
        MENU_ADD_TEXT_TEAM_NUMBER: string;
        MENU_GET_MY_DESIGNS_LINK: string;
        MENU_OPEN_BACKGROUND: string;
        MENU_OPEN_LAYERS: string;
        MENU_GET_DESIGN_DETAIL_LINK: string;
    }
}

const MenuContainer: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const {admin} = props;

    useEffect(() => {
        try {
            ValidateModel.isWindowFce('MENU_ADD_TEXT', window.MENU_ADD_TEXT);
            ValidateModel.isWindowFce(
                'MENU_ADD_TEXT_TEAM_NAME',
                window.MENU_ADD_TEXT_TEAM_NAME
            );
            ValidateModel.isWindowFce(
                'MENU_ADD_TEXT_TEAM_NUMBER',
                window.MENU_ADD_TEXT_TEAM_NUMBER
            );
            ValidateModel.isWindowFce(
                'MENU_GET_MY_DESIGNS_LINK',
                window.MENU_GET_MY_DESIGNS_LINK
            );
            ValidateModel.isWindowFce(
                'MENU_OPEN_BACKGROUND',
                window.MENU_OPEN_BACKGROUND
            );
            ValidateModel.isWindowFce(
                'MENU_OPEN_LAYERS',
                window.MENU_OPEN_LAYERS
            );
            ValidateModel.isWindowFce(
                'MENU_GET_DESIGN_DETAIL_LINK',
                window.MENU_GET_DESIGN_DETAIL_LINK
            );
        } catch (error: any) {
            dispatch(
                actions.addSnackbar(
                    t('Menu is not properly defined. ') + error.message,
                    SnackBarType.WARNING,
                    false
                )
            );
        }

        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <MainMenu admin={admin} />;
};

export default MenuContainer;
